import { defineComponent as i, openBlock as t, createElementBlock as a, mergeProps as u, unref as o, renderSlot as H, createElementVNode as e, createCommentVNode as h } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, f = { key: 1 }, w = { key: 2 }, k = { key: 3 }, A = { key: 4 }, M = { key: 5 }, Z = {
  name: "ScalarIconArrowUDownLeft"
}, v = /* @__PURE__ */ i({
  ...Z,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = g(s);
    return (p, l) => (t(), a("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      H(p.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", m, l[0] || (l[0] = [
        e("path", { d: "M236,112a68.07,68.07,0,0,1-68,68H61l27.52,27.51a12,12,0,0,1-17,17l-48-48a12,12,0,0,1,0-17l48-48a12,12,0,1,1,17,17L61,156H168a44,44,0,0,0,0-88H80a12,12,0,0,1,0-24h88A68.07,68.07,0,0,1,236,112Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", f, l[1] || (l[1] = [
        e("path", {
          d: "M80,120v96L32,168Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M168,48H80a8,8,0,0,0,0,16h88a48,48,0,0,1,0,96H88V120a8,8,0,0,0-13.66-5.66l-48,48a8,8,0,0,0,0,11.32l48,48A8,8,0,0,0,88,216V176h80a64,64,0,0,0,0-128ZM72,196.69,43.31,168,72,139.31Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", w, l[2] || (l[2] = [
        e("path", { d: "M232,112a64.07,64.07,0,0,1-64,64H88v40a8,8,0,0,1-13.66,5.66l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,88,120v40h80a48,48,0,0,0,0-96H80a8,8,0,0,1,0-16h88A64.07,64.07,0,0,1,232,112Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", k, l[3] || (l[3] = [
        e("path", { d: "M230,112a62.07,62.07,0,0,1-62,62H46.49l37.75,37.76a6,6,0,1,1-8.48,8.48l-48-48a6,6,0,0,1,0-8.48l48-48a6,6,0,0,1,8.48,8.48L46.49,162H168a50,50,0,0,0,0-100H80a6,6,0,0,1,0-12h88A62.07,62.07,0,0,1,230,112Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", A, l[4] || (l[4] = [
        e("path", { d: "M232,112a64.07,64.07,0,0,1-64,64H51.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48a8,8,0,0,1,11.32,11.32L51.31,160H168a48,48,0,0,0,0-96H80a8,8,0,0,1,0-16h88A64.07,64.07,0,0,1,232,112Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", M, l[5] || (l[5] = [
        e("path", { d: "M228,112a60.07,60.07,0,0,1-60,60H41.66l41.17,41.17a4,4,0,0,1-5.66,5.66l-48-48a4,4,0,0,1,0-5.66l48-48a4,4,0,0,1,5.66,5.66L41.66,164H168a52,52,0,0,0,0-104H80a4,4,0,0,1,0-8h88A60.07,60.07,0,0,1,228,112Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  v as default
};
